exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EmptyButton_button_3oPd {\n  position: relative;\n  padding: 0;\n\n  line-height: 0;\n\n  color: #000;\n  border: none;\n  border-radius: unset;\n  background: none;\n\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"button": "EmptyButton_button_3oPd"
};